import {Form, InputNumber, Modal,  App, Input,Row, Col, DatePicker, Space, Spin } from 'antd'    
import {  useDingdanshouruUpdateSaveMutation, useDingdanshouruUpdateQuery, useSKtijiaoMutation } from '../../store/DianShangYeWuApi'; 
import React, { useEffect, useState } from 'react'
import classes from './income.module.css'
import OCRTextArea from '../../cpn/OCRTextArea';
import UploadPic from '../../cpn/UploadPic';
import ReportDeptSelect from '../../system/dept/DeptSelect';  // 【差异】IncomeEditReportEdit 用 ReportCheck，无 ReportDeptSelect
import ClientSelect from '../../system/client/ClientSelect';
import dayjs from 'dayjs';
import Icon from '../../cpn/Icon';
import IncomeDel from './IncomeDel';
import DocumentRule from '../../cpn/DocumentRule';
import Asterisk from '../../cpn/Asterisk';
import StateTag from '../../cpn/StateTag';
import IncomeNodeEdit from './IncomeNodeEdit';
import IncomeWithdraw from './IncomeWithdraw';
import ArapTypeSelect from '../../cpn/ArapTypeSelect';
import AccountCheck from 'system/account/AccountCheck';
import { ASSETS_APPLICATION_BASE } from '../../config/api';
function IncomeEdit(props) {
    console.log(props);  // 【差异】IncomeEditReportEdit 无此 console.log
    const { message } = App.useApp();
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'ddsr_price': '',
        'ddsr_uid': props.yh_id,
        'ddsr_uname': props.yh_name,
        'ddsr_content': '',
        'ddsr_bzd_id': '',
        'ddsr_kh_id': '',
        'ddsr_kh_name': '',
        'ddsr_type_id': '',
        'ddsr_type_name': '',
        'ddsr_amount': '',
        'ddsr_qy_id': props.qy_id,
        'ddsr_qy_name': props.qy_name,
        'ddsr_num': '',
        'ddsr_date': '',
        'ddsr_bzd_name': '',
        'ddsr_bzd_date': '',
        'ddsr_bzd_xuhao': '',
        'ddsr_name': '',
        'ddsr_bzd_date_end': '',
        'ddsr_qyyhzh_id': '',
        'ddsr_qyyhzh_name': '',
        'ddsr_bm_id': '',
        'ddsr_bm_name': '',
        'ddsr_image_name': '',
        'ddsr_image_file': '',
        'ddsr_state': ''  // 【差异】IncomeEditReportEdit 另有 'ddsr_qyyhzh_date': ''
    })
    const [form] = Form.useForm();
    const [updateSave] = useDingdanshouruUpdateSaveMutation();
    const [defaultFileList, setDefaultFileList] = useState([]);
    // 与 ReportEdit 一致：打开时再请求，切换单据时强制刷新
    const { data, isSuccess, isFetching } = useDingdanshouruUpdateQuery(
        { ddsr_id: props.ddsr_id },
        { skip: !open, refetchOnMountOrArgChange: 1 }
    );

    // 与 ReportEdit.js 相同结构：先 setInfo / defaultFileList，再在 open 时用 setTimeout 写入表单（含 Upload 的 fileList）
    useEffect(() => {
        if (!isSuccess || !data || String(data.Status || '').toLowerCase() !== 'success' || !data.Result) {
            return;
        }
        const result = data.Result;

        setInfo((prevState) => ({
            ...prevState,
            ddsr_price: result.ddsr_price,
            ddsr_uid: result.ddsr_uid,
            ddsr_uname: result.ddsr_uname,
            ddsr_content: result.ddsr_content,
            ddsr_bzd_id: result.ddsr_bzd_id,
            ddsr_kh_id: result.ddsr_kh_id,
            ddsr_kh_name: result.ddsr_kh_name,
            ddsr_name: result.ddsr_name,
            ddsr_type_name: result.ddsr_type_name,
            ddsr_num: result.ddsr_num,
            ddsr_bm_name: result.ddsr_bm_name,
            ddsr_date: result.ddsr_date,
            ddsr_qyyhzh_name: result.ddsr_qyyhzh_name,
            ddsr_image_file: Array.isArray(result.ddsr_image_file)
                ? result.ddsr_image_file
                : result.ddsr_image_file
                  ? [result.ddsr_image_file]
                  : [],
            ddsr_image_name: Array.isArray(result.ddsr_image_name)
                ? result.ddsr_image_name
                : result.ddsr_image_name
                  ? [result.ddsr_image_name]
                  : [],
            ddsr_zflx: result.ddsr_zflx,
            ddsr_amount: result.ddsr_amount,
            ddsr_state: result.ddsr_state,
            ddsr_ctime: result.ddsr_ctime,
            ddsr_state_time: result.ddsr_state_time,
            ddsr_bzd_name: result.ddsr_bzd_name,
            ddsr_bzd_date: result.ddsr_bzd_date,
            ddsr_bzd_xuhao: result.ddsr_bzd_xuhao,
            ddsr_bzd_date_end: result.ddsr_bzd_date_end,
            ddsr_qyyhzh_id: result.ddsr_qyyhzh_id,
            ddsr_bm_id: result.ddsr_bm_id,
        }));

        const imageNameArray = Array.isArray(result.ddsr_image_name)
            ? result.ddsr_image_name.filter(Boolean)
            : result.ddsr_image_name
              ? [result.ddsr_image_name]
              : [];
        const imageFileArray = Array.isArray(result.ddsr_image_file)
            ? result.ddsr_image_file.filter(Boolean)
            : result.ddsr_image_file
              ? [result.ddsr_image_file]
              : [];

        const fileListForForm = imageNameArray.map((serverFileName, i) => {
            let fullUrl = serverFileName;
            if (serverFileName.startsWith('http://') || serverFileName.startsWith('https://')) {
                fullUrl = serverFileName;
            } else if (serverFileName.startsWith('/')) {
                if (!serverFileName.startsWith('/api/') && !serverFileName.startsWith('/NeiZhangApi/')) {
                    fullUrl = `/api${serverFileName}`;
                } else {
                    fullUrl = serverFileName;
                }
            } else {
                fullUrl = `${ASSETS_APPLICATION_BASE}/${serverFileName}`;
            }
            const displayName = imageFileArray[i] || undefined;
            return {
                uid: `file-${i}-${serverFileName}`,
                name: displayName || serverFileName || `文件${i + 1}`,
                status: 'done',
                url: fullUrl,
                response: { Result: serverFileName },
            };
        });

        // 传给 UploadPic 的必须是对象数组（组件内会过滤掉纯字符串）
        setDefaultFileList(fileListForForm);

        if (open && props.ddsr_id != null && String(props.ddsr_id) !== '') {
            setTimeout(() => {
                form.setFieldsValue({
                    ddsr_price: result.ddsr_price,
                    ddsr_uid: result.ddsr_uid,
                    ddsr_uname: result.ddsr_uname,
                    ddsr_content: result.ddsr_content,
                    ddsr_bzd_id: result.ddsr_bzd_id,
                    ddsr_kh_id: result.ddsr_kh_id,
                    ddsr_kh_name: result.ddsr_kh_name,
                    ddsr_name: result.ddsr_name,
                    ddsr_type_name: result.ddsr_type_name,
                    ddsr_num: result.ddsr_num,
                    ddsr_bm_name: result.ddsr_bm_name,
                    ddsr_date: dayjs(result.ddsr_date),
                    ddsr_qyyhzh_name: result.ddsr_qyyhzh_name,
                    ddsr_image_file: fileListForForm,
                    ddsr_image_name: imageNameArray,
                    ddsr_zflx: result.ddsr_zflx,
                    ddsr_amount: result.ddsr_amount,
                });
            }, 50);
        }
    }, [isSuccess, data, form, open, props.ddsr_id]);
     //提交收款单
     const [tijiao] = useSKtijiaoMutation()
     const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <a onClick={() => {setOpen(true)}} >{props.ddsr_state==='4'&&<span style={{color:"red"}}>已驳回：</span>}{props.ddsr_kh_name}</a>
            <Modal
                open={open} 
                destroyOnClose
                onCancel={() => {
                    setOpen(false);
                    setTimeout(() => {
                        form.resetFields();
                    }, 100);
                }}
                width={1330}
                form={form}
                footer={null}
            >
                <Spin spinning={open && isFetching} tip="数据加载中...">
                <Form
                    form={form}
                    name={`income_edit_${props.ddsr_id || 'new'}`}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #FF0033',borderLeft:'3px solid #FF0033'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#FF0033',borderTop:'3px solid #FF0033'}}>收款单</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #FF0033',borderRight:'3px solid #FF0033'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #FF0033',color:'#FF0033'}}><Asterisk color='red'/> 收款事由</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <Form.Item name='ddsr_name' noStyle>
                                <Input 
                                    placeholder='请输入收款事由' 
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, ddsr_name: e.target.value }))
                                    }}
                                />
                            </Form.Item>
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <ClientSelect
                                name='ddsr_kh_name'
                                placeholder='请选择客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, ddsr_kh_id: value, ddsr_kh_name: label }))
                                }}
                                style={{ width: '310px' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.ddsr_kh_id}
                                wrapperCol={{span:24}}
                            />
                        </Col>  
                        {/* 【差异】部门：此处为 ReportDeptSelect 可选；IncomeEditReportEdit 仅只读展示 info.ddsr_bm_name */}
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='black'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #FF0033'}}>
                            <ReportDeptSelect
                                yh_id={props.yh_id}
                                wrapperCol={{span:24}}
                                placeholder='请选择部门'
                                qy_id={props.qy_id}
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, ddsr_bm_id: e, ddsr_bm_name: f }))
                                }}
                                name="ddsr_bm_name"
                                defaultId={info.ddsr_bm_id}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                            />
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033'}}><Asterisk color='red'/> 日期</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='ddsr_date' noStyle>
                                <DatePicker 
                                    placeholder='请选择日期' 
                                    onChange={(value) => {
                                        setInfo(prevState => ({ ...prevState, ddsr_date: dayjs(value).format('YYYY-MM-DD') }))
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 金额</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='ddsr_amount' noStyle>
                                <InputNumber 
                                    placeholder='请输入金额' 
                                    onChange={(value) => {
                                        setInfo(prevState => ({ ...prevState, ddsr_amount: value }))
                                    }}
                                    style={{ width: '310px' }}
                                    min={0.01}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 往来类型</Col>
                        <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #FF0033'}}>
                            <ArapTypeSelect 
                                documentType='income' 
                                onChange={(value) => {
                                    setInfo(prevState => ({ ...prevState, ddsr_zflx: value }))
                                }}
                                name='ddsr_zflx'
                                required={true}
                                style={{marginBottom: 0}}
                                wrapperCol={{span:24}}
                            />
                            {/* 【差异】IncomeEditReportEdit 的 ArapTypeSelect 有 disabled='核销应收' */}
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033'}}> 备注</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='ddsr_content' noStyle>
                                <OCRTextArea
                                    value={info.ddsr_content}
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, ddsr_content: e.target.value }))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col>                        
                        {/* 【差异】团队名称：此处仅展示文案；IncomeEditReportEdit 用 ReportCheck 组件 */}
                        <Col span={2} className={classes.col_middle_label}>团队名称</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            {info.ddsr_bzd_name}
                        </Col>                                       
                        <Col span={2}  className={classes.col_middle_label}> 转账记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid #FF0033',padding:'20px 5px'}}>
                            {info.ddsr_qyyhzh_date} <AccountCheck qyyhzh_id={info.ddsr_qyyhzh_id} name={info.ddsr_qyyhzh_name} />
                        </Col>                                   
                        {/* 第四行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF0033'}}> 附件</Col>
                        <Col span={14}  className={classes.col_middle_input}>
                            <UploadPic
                                name="ddsr_image_file"
                                defaultFileList={defaultFileList}
                                onChange={(fileNames, fileUrls) => {
                                    setInfo((prevState) => ({
                                        ...prevState,
                                        ddsr_image_file: Array.isArray(fileNames)
                                            ? fileNames
                                            : fileNames
                                              ? [fileNames]
                                              : [],
                                        ddsr_image_name: Array.isArray(fileUrls)
                                            ? fileUrls
                                            : fileUrls
                                              ? [fileUrls]
                                              : [],
                                    }));
                                }}
                                maxCount={5}
                                style={{ width: '100%' }}
                                formStyle={{ marginBottom: 0, width: '100%' }}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}>编号/状态</Col>
                        <Col span={6}  className={classes.col_middle_right_input}  style={{borderRight:'3px solid #FF0033'}}>{props.ddsr_id}&emsp;<StateTag state={info.ddsr_state} /></Col>
                         {/* 第五行 */}                        
                         <Col span={24} className={classes.bottom_row}>
                            <IncomeNodeEdit 
                                qy_id={props.qy_id} 
                                qy_name={props.qy_name}
                                user_id={props.yh_id} 
                                yh_id={props.yh_id}
                                yh_name={props.yh_name} 
                                ddsr_id={props.ddsr_id} 
                                ddsr_state={info.ddsr_state}
                                ddsr_ctime={info.ddsr_ctime}
                                ddsr_uname={info.ddsr_uname}
                                ddsr_state_time={info.ddsr_state_time}
                                ddsr_bm_id={info.ddsr_bm_id}
                                ddsr_zflx={info.ddsr_zflx}
                            />
                        </Col>                        
                    </Row>   

                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Form.Item name='ddsr_state' noStyle>
                                <Space size={20}>
                                    <Icon key='submit' type='save' onClick={() => {
                                        if(info.ddsr_name === ''){
                                            message.error('请输入收款事由');
                                            return;
                                        }
                                        if(info.ddsr_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }
                                        if(info.ddsr_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.ddsr_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        if(info.ddsr_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }
                                        if(info.ddsr_zflx === ''){
                                            message.error('请选择往来类型');
                                            return;
                                        }
                                        updateSave({
                                            'ddsr_id': props.ddsr_id,
                                            'ddsr_price': info.ddsr_price,
                                            'ddsr_uid': props.yh_id,
                                            'ddsr_uname': props.yh_name,
                                            'ddsr_content': info.ddsr_content,
                                            'ddsr_bzd_id': info.ddsr_bzd_id,
                                            'ddsr_kh_id': info.ddsr_kh_id,
                                            'ddsr_kh_name': info.ddsr_kh_name,
                                            'ddsr_type_id': info.ddsr_type_id?info.ddsr_type_id:'',
                                            'ddsr_type_name': info.ddsr_type_name?info.ddsr_type_name:'',
                                            'ddsr_amount': info.ddsr_amount,
                                            'ddsr_qy_id': props.qy_id,
                                            'ddsr_qy_name': props.qy_name,
                                            'ddsr_num': info.ddsr_num,
                                            'ddsr_date': info.ddsr_date,
                                            'ddsr_bzd_name': info.ddsr_bzd_name,
                                            'ddsr_bzd_date': info.ddsr_bzd_date,
                                            'ddsr_bzd_xuhao': '',
                                            'ddsr_name': info.ddsr_name,
                                            'ddsr_bzd_date_end': info.ddsr_bzd_date_end,
                                            'ddsr_qyyhzh_id': info.ddsr_qyyhzh_id,
                                            'ddsr_qyyhzh_name': info.ddsr_qyyhzh_name,
                                            'ddsr_bm_id': info.ddsr_bm_id?info.ddsr_bm_id:'',  // 【差异】IncomeEditReportEdit 直接传 info.ddsr_bm_id
                                            'ddsr_bm_name': info.ddsr_bm_name?info.ddsr_bm_name:'',  // 【差异】IncomeEditReportEdit 直接传 info.ddsr_bm_name
                                            'ddsr_image_name': info.ddsr_image_name?info.ddsr_image_name:'',
                                            'ddsr_image_file': info.ddsr_image_file?info.ddsr_image_file:'',
                                            'ddsr_state': '1',
                                            'ddsr_zflx': info.ddsr_zflx,
                                            
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('修改成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('修改失败！' + res.data.Message);
                                            }
                                        })     
                                    }}/>  
                                    {props.ddsr_state === '2' && <IncomeWithdraw ddsr_id={props.ddsr_id} />}
                                    {/* 【差异】IncomeEditReportEdit 仅 ddsr_state === '1' 时显示删除 */}
                                    {(props.ddsr_state === '1'|| props.ddsr_state === '4') && <IncomeDel ddsr_id={props.ddsr_id} />}
                                    <Icon 
                                        type='submit' 
                                        onClick={() => {
                                            // 如果正在提交中，直接返回
                                            if (isSubmitting) {
                                                return;
                                            }
                                            
                                            // 先进行验证
                                        
                                            if(info.ddsr_name === ''){
                                                message.error('请输入收款事由');
                                                return;
                                            }
                                            if(info.ddsr_amount === ''){
                                                message.error('请输入金额');
                                                return;
                                            }

                                            if(info.ddsr_kh_id === ''){
                                                message.error('请选择客户');
                                                return;
                                            }

                                            if(info.ddsr_bm_id === ''){
                                                message.error('请选择部门');
                                                return;
                                            }
                                            if(info.ddsr_date === ''){
                                                message.error('请选择日期');
                                                return;
                                            }
                                            if(info.ddsr_zflx === ''){
                                                message.error('请选择往来类型');
                                                return;
                                            }
                                            // 【差异】IncomeEditReportEdit 的提交前还会校验 info.ddsr_zflx
                                            // 验证通过后，设置提交状态
                                            setIsSubmitting(true);
                                            tijiao({
                                                'ddsr_id': props.ddsr_id,
                                                'ddsr_uid': props.yh_id,  
                                                'ddsr_uname': props.yh_name,
                                                'qy_id': props.qy_id,
                                                'qy_name': props.qy_name,
                                                'ddsr_name': info.ddsr_name,
                                                'ddsr_date': info.ddsr_date,
                                                'ddsr_kh_id': info.ddsr_kh_id, 
                                                'ddsr_kh_name': info.ddsr_kh_name,
                                                'ddsr_sp_ddsr_amount': info.ddsr_amount,
                                                'ddsr_sp_ddsr_content': info.ddsr_content,
                                                'ddsr_sp_dsbzd_id': props.ddsr_bzd_id,
                                                'ddsr_sp_dsbzd_name': props.ddsr_bzd_name,
                                                'ddsr_bm_id': info.ddsr_bm_id,
                                                'ddsr_bm_name': info.ddsr_bm_name,
                                                'ddsr_image_name': info.ddsr_image_name?info.ddsr_image_name:'',
                                                'ddsr_image_file': info.ddsr_image_file?info.ddsr_image_file:'',
                                                'ddsr_zflx': info.ddsr_zflx,
                                                'ddsr_spjd_bm_id': info.ddsr_bm_id,
                                                'ddsr_spjd_zflx': info.ddsr_zflx,
                                                'ddsr_spjd_amount': info.ddsr_amount,
                                                // 【差异】IncomeEditReportEdit 的 tijiao 还传 'ddsr_spjd_user_id': props.yh_id
                                            }).then(res => {
                                                if(res.data.Status === 'success') {
                                                    message.success('收款单提交成功！')
                                                } else {
                                                    message.error('收款单提交失败！'+res.data.Message)
                                                }
                                            })
                                            .catch((err) => {
                                                message.error('收款单提交失败！'+(err.response?.data?.Message||''))
                                            })
                                            .finally(() => {
                                                setIsSubmitting(false);
                                            })
                                        }} 
                                        disabled={isSubmitting}
                                        style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                    />  
                                </Space>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                </Spin>
            </Modal>

        </>
    )
}

export default IncomeEdit